import React from 'react';
import { Fab, Tooltip } from '@material-ui/core';

const RMSFabIconButton = ({
  icon,
  color = 'primary',
  size = 'small',
  tooltip,
  onClick,
  disabled = false,
  ...rest
}) => {
  const fab = (
    <Fab color={color} size={size} variant="round" onClick={onClick} disabled={disabled} {...rest}>
      {icon}
    </Fab>
  );

  return (
    tooltip && (
      <Tooltip title={tooltip} placement="top">
        <span>{fab}</span>
      </Tooltip>
    )
  );
};

export default RMSFabIconButton;

/**
 * Available Props:
 * icon       : ReactNode
 * label      : string
 * color      : 'primary' | 'secondary' | 'inherit' | 'default'
 * size       : 'small' | 'medium' | 'large'
 * tooltip    : string
 * disabled   : boolean
 * onClick    : function
 *
 * Supports all Material UI <Fab /> props via ...rest.
 *
 * Example:
 * <RMSFabIconButton
 *   icon={<SaveIcon />}
 *   label="Save"
 *   color="secondary"
 *   size="medium"
 *   onClick={handleSave}
 * />
 */
